var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcRate4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2138 45.2855C46.3906 47.6292 44.0562 49.5256 41.3888 50.8301C38.7213 52.1345 35.7911 52.8126 32.8218 52.8125H8.23877C6.94584 52.8125 5.70586 52.2989 4.79162 51.3846C3.87738 50.4704 3.36377 49.2304 3.36377 47.9375V30.875C3.36377 29.5821 3.87738 28.3421 4.79162 27.4279C5.70586 26.5136 6.94584 26 8.23877 26H28.4668C29.5738 26.0003 30.6478 26.3774 31.512 27.0693L40.4138 34.177C41.0213 34.663 41.7362 34.9965 42.4989 35.1497C43.2617 35.303 44.05 35.2714 44.798 35.0577L59.4263 30.875L48.2138 45.2855Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8638 16.25V26",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1138 16.25H32.6138",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4263 30.875L66.7388 33.3125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0511 60.4305C74.0511 62.2889 73.3129 64.0711 71.9988 65.3852C70.6847 66.6993 68.9025 67.4375 67.0441 67.4375C65.1857 67.4375 63.4035 66.6993 62.0894 65.3852C60.7753 64.0711 60.0371 62.2889 60.0371 60.4305C60.0371 56.55 64.7074 48.75 67.0441 48.75C69.3809 48.75 74.0511 56.55 74.0511 60.4305Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcRate4);
export default __webpack_public_path__ + "static/media/exc_rate4.580f4d3a6173956ab8173f646f7c3896.svg";
export { ForwardRef as ReactComponent };